import React, { useEffect, useState } from "react";
import SelectComp from "../../../components/Select";
import Input from "../../../components/Input";
import Button from "../../../components/ButtonUI";
import { Formik, useFormikContext } from "formik";
import {
  getAllCampaigns,
  deleteCampaign,
  addCampaign,
  updateCampaign,
  getCampaignByNumeroFacture,
} from "../../../api/screeningEvent";
import makeToast from "../../../components/Snackbar";
import Icon from "../../../components/Icon";

interface FormValues {
  clientId: string;
  numeroFacture: string;
  nbJournees?: number | null;
}

interface Props {
  clientList: any[];
  setShowAgendaModal: Function;
}

function ListCampagne({ clientList, setShowAgendaModal }: Props) {
  const [campaignList, setCampaignList] = useState<any[]>([]);
  const [search, setSearch] = useState<string>("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCampaignId, setSelectedCampaignId] = useState<string | null>(
    null,
  );
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState<any>(null);
	const [numeroError, setNumeroError] = useState("");
  const filteredList = campaignList.filter((c) =>
    c.clientId?.name?.toLowerCase().includes(search.toLowerCase()),
  );
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedCampaigns = filteredList.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  const fetchCampaigns = async () => {
    const res = await getAllCampaigns();
    const list = Array.isArray(res) ? res : res.response || res.data || [];
    setCampaignList(list);
  };

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const handleDelete = async () => {
    if (!selectedCampaignId) return;

    try {
      await deleteCampaign(selectedCampaignId);
      setCampaignList((prev) =>
        prev.filter((c) => c._id !== selectedCampaignId),
      );
      setShowDeleteModal(false);
      setSelectedCampaignId(null);
      makeToast("success", "Campagne supprimée avec succès");
    } catch (error) {
      console.error(error);
      makeToast("error", "Erreur lors de la suppression");
    }
  };

  const handleUpdateCampaign = async () => {
		
    try {
      if (!selectedCampaign) return
      const payload = {
        clientId: selectedCampaign.clientId._id,
        nbJournees: selectedCampaign.nbJournees,
				numeroFacture: selectedCampaign.numeroFacture
      };
      const a = await updateCampaign(selectedCampaign._id, payload);
			if(a===undefined){
				makeToast("error", "Erreur lors de la mise à jour");
				return
			}
      await fetchCampaigns();

      setShowEditModal(false);
      setSelectedCampaign(null);

      makeToast("success", "Campagne mise à jour !");
    } catch (error) {
      console.error(error);
      makeToast("error", "Erreur lors de la mise à jour");
    }
  };

	useEffect(() => {
		if (!selectedCampaign?.numeroFacture) {
			setNumeroError("");
			return;
		}

		const timeout = setTimeout(async () => {
			try {
				const exists = await getCampaignByNumeroFacture(
					selectedCampaign.numeroFacture,
					selectedCampaign._id
				);
				setNumeroError(exists ? "Ce numéro de devis existe déjà" : "");
			} catch (error) {
				console.error(error);
				setNumeroError("");
			}
		}, 400);

		return () => clearTimeout(timeout);
	}, [selectedCampaign?.numeroFacture, selectedCampaign?._id]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-6 font-medium">
      <div className="w-full max-w-4xl h-full flex flex-col">
        <div className="block w-full rounded-3xl overflow-hidden text-left shadow-2xl bg-white flex-1 flex flex-col">
          <div
            className="flexCenter relative  text-white h-24  py-1"
            style={{ backgroundColor: "#4565f4" }}
          >
            {/* Close modal button */}
            <div className=" absolute right-0  top-0 rounded-bl-3xl border shadow-lg  cursor-pointer -mx-2 -my-2">
              <Icon
                isIcon={true}
                style={{ opacity: 0.5 }}
                name="close"
                onClick={() => {
                  setShowAgendaModal("");
                }}
              />
            </div>
            <div className="">
              <span className="text-xl font-bold  leading-tight capitalize mx-2 w-2/3">
                Liste de Campagne
              </span>
            </div>
          </div>
          <div className="p-4 border-b">
            <Input
              id="search"
              type="text"
              placeholder="Rechercher par client..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="overflow-x-auto max-h-[50vh] m-3">
            <table className="min-w-full bg-white border border-gray-200 rounded-lg">
              <thead>
                <tr className="bg-gray-100 text-left">
                  <th className="px-4 py-2 border-b">Client</th>
                  <th className="px-4 py-2 border-b">Nombre de journées</th>
									<th className="px-4 py-2 border-b">Numéro de devis</th>
                  <th className="px-4 py-2 border-b">Créé à</th>
                  <th className="px-4 py-2 border-b">Mis à jour à</th>
                  <th className="px-4 py-2 border-b">Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginatedCampaigns.map((campaign) => (
                  <tr key={campaign._id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border-b">
                      {campaign.clientId?.name || "N/A"}
                    </td>
                    <td className="px-4 py-2 border-b">
                      {" "}
                      {campaign.usedJournees} / {campaign.nbJournees}
                    </td>
										<td className="px-4 py-2 border-b">
                      {campaign.numeroFacture ? (
												campaign.numeroFacture
											) : (
												<span className="text-gray-400 italic">Non renseigné</span>
											)}
                    </td>
                    <td className="px-4 py-2 border-b">
                      {new Date(campaign.createdAt).toLocaleString("fr-FR", {
                        hour12: false,
                      })}
                    </td>
                    <td className="px-4 py-2 border-b">
                      {new Date(campaign.updatedAt).toLocaleString("fr-FR", {
                        hour12: false,
                      })}
                    </td>
                    <td className="px-4 py-2 border-b flex gap-2">
                      <Button
                        status="primary"
                        className="px-3 py-2 text-sm rounded-lg"
                        onClick={() => {
                          setSelectedCampaign(campaign);
													setNumeroError("");
                          setShowEditModal(true);
                        }}
                      >
                        Mise à jour
                      </Button>
                      <Button
                        className="bg-red-500 px-3 py-2 text-sm rounded-lg hover:bg-red-700"
                        onClick={() => {
                          setSelectedCampaignId(campaign._id);
                          setShowDeleteModal(true);
                        }}
                      >
                        Supprimer
                      </Button>
                    </td>
                  </tr>
                ))}
                {filteredList.length === 0 && (
                  <tr>
                    <td
                      colSpan={5}
                      className="px-4 py-4 text-center text-gray-500"
                    >
                      Aucune campagne trouvée
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="flex justify-between items-center mt-4">
              <span className="text-sm text-gray-600">
                Page {currentPage} sur {totalPages || 1}
              </span>

              <div className="flex gap-2">
                <Button
                  status="secondary"
                  onClick={() => {
                    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
                  }}
                  className={`px-3 py-1 rounded ${
                    currentPage === 1 ? "opacity-40 cursor-not-allowed" : ""
                  }`}
                >
                  Précédent
                </Button>

                <Button
                  status="secondary"
                  onClick={() => {
                    if (currentPage < totalPages)
                      setCurrentPage((prev) => prev + 1);
                  }}
                  className={`px-3 py-1 rounded ${
                    currentPage === totalPages || totalPages === 0
                      ? "opacity-40 cursor-not-allowed"
                      : ""
                  }`}
                >
                  Suivant
                </Button>
              </div>
            </div>

            {showDeleteModal && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
                <div className="bg-white rounded-xl p-6 w-[400px] shadow-lg">
                  <h3 className="text-lg font-semibold mb-4">
                    Confirmer la suppression
                  </h3>

                  <p className="text-gray-600 mb-6">
                    Êtes-vous sûr de vouloir supprimer cette campagne ?
                  </p>

                  <div className="flex justify-end gap-3">
                    <Button
                      status="secondary"
                      onClick={() => setShowDeleteModal(false)}
                      className="px-4 py-2 rounded"
                    >
                      Annuler
                    </Button>

                    <Button
                      status="primary"
                      onClick={handleDelete}
                      className="px-4 py-2 rounded bg-red-500"
                    >
                      Supprimer
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>

          {showEditModal && selectedCampaign && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
              <div className="bg-white rounded-xl p-6 w-[450px] max-w-[90vw] shadow-lg">
                <h3 className="text-lg font-semibold mb-6">
                  Modifier la campagne
                </h3>

                <div className="flex flex-col gap-4">
                  <SelectComp
                    id="editClient"
                    value={selectedCampaign.clientId?._id}
                    options={clientList}
                    onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                      setSelectedCampaign({
                        ...selectedCampaign,
                        clientId: {
                          ...selectedCampaign.clientId,
                          _id: e.target.value,
                        },
                      })
                    }
                    text="Sélectionner le client"
                    className="h-12 px-5 border border-gray-200 rounded-lg"
                  />

                  <Input
                    type="text"
                    inputMode="numeric"
                    value={selectedCampaign.nbJournees ?? ""}
                    placeholder="Nombre de journées"
                    onChange={(e) => {
                      let val = e.target.value.replace(/\D/g, "");
                      val = val.replace(/^0+(?=\d)/, "");

                      setSelectedCampaign({
                        ...selectedCampaign,
                        nbJournees: val === "" ? undefined : Number(val),
                      });
                    }}
                    className="rounded-lg"
                  />
									<Input
										type="text"
										value={selectedCampaign.numeroFacture ?? ""}
										placeholder="Numéro de devis"
										onChange={(e) => {
											const val = e.target.value;

											setSelectedCampaign({
												...selectedCampaign,
												numeroFacture: val,
											});
										}}
										className="rounded-lg"
									/>
                </div>
								{numeroError && (
                              <p className="text-red-500 text-sm">
                                {numeroError}
                              </p>
                            )}

                <div className="flex justify-end gap-3 mt-6">
                  <Button
                    status="secondary"
                    onClick={() => setShowEditModal(false)}
                    className="px-5 py-2"
                  >
                    Annuler
                  </Button>

                  <Button
										status="primary"
										onClick={handleUpdateCampaign}
										disabled={!!numeroError}
										className={`px-5 py-2 ${numeroError ? "opacity-50 cursor-not-allowed" : ""}`}
									>
										Sauvegarder
									</Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ListCampagne;
